import { option } from 'fp-ts';
import { connect as baseConnect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getAgeCategoryMaximalAge, getAgeCategoryMinimalAge } from '../../../modules/entities/ageCategories/selectors';
import { getAgeCategoryLocalizedName } from '../../../selectors/views/ageCategories';
import { ApplicationState } from '../../../types';

interface OwnProps {
    ageCategoryId: string;
}

interface StateProps {
    categoryName: string;
    maximalAge: option.Option<number>;
    minimalAge: option.Option<number>;
}

export const connect = baseConnect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector<ApplicationState, OwnProps, StateProps>({
        categoryName: getAgeCategoryLocalizedName,
        maximalAge: getAgeCategoryMaximalAge,
        minimalAge: getAgeCategoryMinimalAge,
    }),
    {}
);
